import { EpkModuleApiService } from '~packages/epk-front-shared/api-client';
import type {
  Filters,
  IRecDto,
  IResDto,
  IResult,
  Params,
} from '~packages/epk-front-shared/api-client';
import { getFilteredData } from '~packages/epk-front-shared/api-client';
import { Mode, RequestMethod } from '~packages/json-api/client';
import replacePlaceholdersCustom, {
  PathParts,
} from '~packages/json-api/client/helpers/__base/replacePlaceholdersCustom';

import { sleep } from '@/shared/helpers';

const pathList = '/report/ows';

const constructorParams = {
  className: 'OrgsApiService',
  mode: Mode.Production,
  pathFetch: pathList + '/',
  pathFetchAll: pathList,
};

export interface IOrgResDto {
  org_type_org: number;
  org_name: string;
  org_landed_oktmo_code: number;
  org_inn: string;
}

export interface IOrgEmployeeAccessResDto {
  oktmo: number;
  oktmo_locality: string;
  oktmo_oktmo: string;
  type_right_read_only: boolean;
  type_right_read_write: boolean;
  busy_rights: Record<
    'read-only' | 'read-write',
    {
      [k: string]: any;
    }
  >;
}

export interface IOrgEmployeeUserResDto {
  user: string;
  user_department: string | null;
  user_first_name: string;
  user_last_name: string;
  user_is_head: boolean;
  user_is_me: boolean;
  user_username: string;
}

export interface IOrgEmployeeResDto {
  accesses: IOrgEmployeeAccessResDto[];
  user_department: string;
  user: IOrgEmployeeUserResDto;
}

export interface IOrgOktmoResDto {
  [k: string]: unknown;
}

export interface IOrgLoadResDto {
  org: IOrgResDto;
  gen_oktmos: IOrgOktmoResDto[];
  // rights_oktmos_kk: any;
  org_have_head: boolean;
  org_head: IOrgEmployeeUserResDto | null; // bigint ?
  users: IOrgEmployeeResDto[];
}

export interface IOrgDepartmentListLoadParts {
  org: number;
}

export interface IEmployeeDepartmentUpdateParts {
  org: number;
  user: string;
}

export interface IEmployeeDepartmentUpdateReqDto {
  department: string | null;
}

export type OrgDepartmentListLoadResult = IResult<IResDto<IRecDto<any>>>;

export type EmployeeDepartmentApply = IResult<{ department: string }>;

export default class OrgsApiService extends EpkModuleApiService {
  constructor() {
    super(constructorParams);
  }

  async departmentListLoad(
    parts: IOrgDepartmentListLoadParts,
    params?: Params
  ): Promise<OrgDepartmentListLoadResult> {
    return await this._sendRequest(
      replacePlaceholdersCustom(
        '/departments/{org}',
        parts as unknown as PathParts
      ),
      params,
      undefined,
      { method: 'employeeDepartmentList' }
    );
  }

  async departmentListLoadLocal() {
    await sleep(500, true);
    return [
      { id: 1, name: 'Отдел 1' },
      { id: 2, name: 'Отдел 2 с очень длинным названием для демонстрации' },
      { id: 3, name: 'Отдел 3' },
    ];
  }

  async employeeDepartmentApply(
    parts: IEmployeeDepartmentUpdateParts,
    dto: IEmployeeDepartmentUpdateReqDto
  ): Promise<EmployeeDepartmentApply> {
    return await this._sendRequest(
      replacePlaceholdersCustom(
        '/departments/{org}/{user}',
        parts as unknown as PathParts
      ),
      {},
      { body: this.jsonStringify(dto), method: RequestMethod.PUT },
      { method: 'employeeDepartmentUpdate' }
    );
  }

  async employeeDepartmentUpdateLocal(i: any) {
    await sleep(1000, true);
    return i;
  }

  async reportOwsGet(filters: Filters, params: Params) {
    return await getFilteredData(
      this,
      filters,
      params,
      undefined,
      undefined,
      constructorParams.pathFetchAll
    );
  }

  async whoIm(params?: Params) {
    return await this._sendRequest('/who-im', params, undefined, {
      method: 'whoIm',
    });
  }

  async isIm(): Promise<any> {
    return await this._sendRequest(
      '/is-im',
      undefined,
      { method: RequestMethod.POST },
      {
        method: 'isIm',
      }
    );
  }
}
